const errorsEn = {
    "unable_to_create_event": "Unable to create the event. Error code: {{error_code}}",
    "event_delete_error": "Unable to delete the event. Error code: {{error_code}}",
    "guest_info_update_error": "Unable to update guest information. Error code: {{error_code}}",
    "schedule_item_overlap": "The table is already booked for the selected time",
    "move_to_room": "Reservations cannot be placed in a room. Please select a table instead!",
    "move_to_occupied_table": "This table is already occupied at this time. Dragging to occupied tables is disabled.",
    "mail_error": "Failed to send the email. Error code: {{error_code}}",
    "unable_to_update_reservation": "Unable to update the reservation. Error code: {{error_code}}",
    "sms_error": "Failed to send the SMS. Error code: {{error_code}}",
    "date_range_max": "The date range cannot exceed {{days}} days",
    "outstanding_invoice_alert": "Please note that you currently have {{count}} overdue invoice(s). Kindly settle your outstanding balance as soon as possible. Be aware that if the debt exceeds 30 days, our service may be suspended.",
    "no_access_to_page": "You do not have access to this page.",
    "no_access_helper": "If you think this is an error, please contact the restaurant administrator.",
    "image_upload_error": "Failed to upload the image. Error code: {{error_code}}",
    "max_character_length": "Maximum length: {{max_length}} characters",
}

export default errorsEn;